import { createFocusContainer, removeFocusContainer, addTimer } from "../helpers-focus.js";
/*
 * Adds a focus container that contains a scrollable item, updates points for scrolling
 */
function scrollTime({ gameState, board }) {
  const focusContainer = createFocusContainer({ board });
  const outerDiv = document.createElement("div");
  const innerDiv = document.createElement("div");
  const totalSeconds = 5;

  return new Promise((resolve) => {
    const { timerDiv, startTimer, getSeconds } = addTimer(totalSeconds, () => {
      removeFocusContainer(focusContainer, { board })
      resolve();
    });
    outerDiv.classList.add("scroll__outer");
    innerDiv.classList.add("scroll__inner");
    focusContainer.appendChild(timerDiv);
    focusContainer.appendChild(outerDiv);
    outerDiv.appendChild(innerDiv);

    let minScroll = 100;
    let lastScroll = 0;
    let totalScroll = 0
    outerDiv.addEventListener('scroll', () => {
      if (getSeconds() <= 0) return;
      const MULTIPLYER = 5;

      totalScroll += Math.abs(outerDiv.scrollTop - lastScroll);
      lastScroll = outerDiv.scrollTop;

      if (totalScroll >= minScroll) {
        gameState.updateScore(100);
        minScroll = minScroll * MULTIPLYER;
      }
    })
    startTimer();
  });
}

export default scrollTime;
